import { render, staticRenderFns } from "./tabelaDebitosSelecionados.vue?vue&type=template&id=4b287978"
import script from "./tabelaDebitosSelecionados.vue?vue&type=script&lang=js"
export * from "./tabelaDebitosSelecionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports